<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.systemSettings') }}</h3>
      </d-col>
    </d-row>

    <d-row>
      <d-col
        lg
        col
        :cols="3"
        v-for="(card, index) in cards" :key="'card-' + index">
        <d-card class="card card-small text-center mb-4">
            <d-card-body>
              <router-link :to="card.link">
                <h3 class="display-4 mt-2 mb-2">
                  <i class="material-icons text-primary" style="font-size: 64px;">
                    {{ card.icon }}
                  </i>
                </h3>

                {{ card.label }}
              </router-link>
            </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>

export default {
  name: 'settings',
  computed: {
    cards () {
      return [
        {
          label: this.$t('settings.country.countries'),
          icon: 'outlined_flag',
          link: '/ustawienia/kraje'
        },
        {
          label: this.$t('settings.language.languages'),
          icon: 'language',
          link: '/ustawienia/jezyki'
        },
        {
          label: this.$t('settings.currency.currencies'),
          icon: 'attach_money',
          link: '/ustawienia/waluty'
        },
        {
          label: this.$t('settings.transaltion.dictionaryMultilang'),
          icon: 'library_books',
          link: '/ustawienia/slowniki-wielojezycznosci'
        },
        {
          label: this.$t('settings.userGroups.userGroups'),
          icon: 'folder_shared',
          link: '/ustawienia/grupy-uzytkownikow'
        },
        {
          label: this.$t('settings.customerTags.customersTags'),
          icon: 'local_offer',
          link: '/ustawienia/tagi-klientow'
        },
        {
          label: this.$t('settings.orderTags.ordersTags'),
          icon: 'local_offer',
          link: '/ustawienia/tagi-zamowien'
        },
        {
          label: this.$t('settings.customerContactTypes.contactTypes'),
          icon: 'phone_in_talk',
          link: '/ustawienia/typy-kontaktow-z-klientem'
        },
        {
          label: this.$t('settings.processingTime.processingTimes'),
          icon: 'alarm',
          link: '/ustawienia/czas-realizacji'
        },
        {
          label: this.$t('settings.integrations.integrations'),
          icon: 'cloud_sync',
          link: '/ustawienia/integracje'
        },
        {
          label: this.$t('settings.confirmations.confirmations'),
          icon: 'check_circle',
          link: '/ustawienia/potwierdzenia'
        },
        {
          label: this.$t('settings.emailTemplates.emailTemplates'),
          icon: 'email',
          link: '/ustawienia/szablony-email'
        },
        {
          label: this.$t('shippers.shippersLabel'),
          icon: 'local_shipping',
          link: '/ustawienia/spedytorzy'
        },
      ];
    }
  }
};
</script>
